import { StructureGridCollection } from 'types/api-responses';

const VALIDITY_SORT_ORDER: Record<string, number> = {
  valid: 1,
  success: 1,
  warning: 2,
  incomplete: 3,
  invalid: 4,
  flagged: 4,
  error: 5,
};

export const sortCollections = (
  collections: StructureGridCollection[]
): StructureGridCollection[] =>
  [...collections].sort((a, b) => {
    if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
    const aOrder = VALIDITY_SORT_ORDER[a.validity] ?? 6;
    const bOrder = VALIDITY_SORT_ORDER[b.validity] ?? 6;
    if (aOrder !== bOrder) return aOrder - bOrder;
    return a.collectionId - b.collectionId;
  });
